import { PropsWithChildren, useEffect, useState } from "react";
import { authRegisterRequest } from "../api/AuthApi";
import { useAuth } from "react-oidc-context";
import { registerProductManagerUser } from "./product-manager/product-manager.service";
import { registerBankManagerUser } from "./bank-manager/bank-manager.service";


export interface CreateUserProps extends PropsWithChildren { }
export function CreateUser({ children }: CreateUserProps) {

    const auth = useAuth()

    const [done, setDone] = useState<boolean>(false)

    useEffect(() => {
        if (auth?.isAuthenticated) {
            Promise.all([
                registerBankManagerUser(),
                registerProductManagerUser(),
                authRegisterRequest()
                    .then((data) => console.log(data))

            ]).then(() => setDone(true))
                .catch((error) => console.error(error))
        }
    }, [auth])

    return <>
        {done ? children : null}
    </>
}